<mat-accordion>
  <mat-expansion-panel *ngIf = "!isShowOtherDocumentOnly && treatyItems && treatyItems.length > 0 && isReadyTreatyDocument" [expanded] = "isTreatyExpanded">
    <mat-expansion-panel-header >
      <mat-panel-title>
        Tax Treaty Documents
      </mat-panel-title>
    </mat-expansion-panel-header>

    <mat-list>
      <mat-list-item *ngFor = "let item of treatyItems">
        <a [id]="item.documentId" (click) = "clicked(item)" [ngClass]="{'active': item.isActive===true}"> {{item.title}}</a>
      </mat-list-item>
    </mat-list>
  </mat-expansion-panel>

  <mat-expansion-panel *ngIf = "otherDocuments && otherDocuments.length > 0 && isReadyOtherTreatyDocument" [expanded] = "isOtherTreatyExpanded">
    <mat-expansion-panel-header>
      <mat-panel-title>
        Other Tax Treaty Documents
      </mat-panel-title>
    </mat-expansion-panel-header>

      <mat-accordion #firstAccordion = "matAccordion">
        <mat-expansion-panel *ngFor = "let otherDocumentGroup of otherDocuments" [expanded] = "otherDocumentGroup.isExpanded">
         <mat-expansion-panel-header>
            {{otherDocumentGroup.groupTitle}}
          </mat-expansion-panel-header>
          <mat-list-item *ngFor = "let otherDocument of otherDocumentGroup.navigation">
            <a [id]="otherDocument.documentId" (click) = "clicked(otherDocument)" [ngClass]="{'active': otherDocument.isActive===true}"> {{otherDocument.title}}</a>
          </mat-list-item>
        </mat-expansion-panel>
      </mat-accordion>

  </mat-expansion-panel>

  <mat-expansion-panel *ngIf = "socialSecurityItems && socialSecurityItems.length > 0 && isReadySocialSecurityDocument" [expanded] = "isSocialSecurityExpanded">
    <mat-expansion-panel-header >
      <mat-panel-title>
        Social Security Agreement Documents
      </mat-panel-title>
    </mat-expansion-panel-header>

    <mat-list>
      <mat-list-item *ngFor = "let item of socialSecurityItems">
        <a [id]="item.documentId" (click) = "clicked(item)" [ngClass]="{'active': item.isActive===true}"> {{item.title}}</a>
      </mat-list-item>
    </mat-list>
  </mat-expansion-panel>

</mat-accordion>
